import { render, staticRenderFns } from "./EditDoctorModal.vue?vue&type=template&id=010e1dc9"
import script from "./EditDoctorModal.vue?vue&type=script&lang=ts"
export * from "./EditDoctorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports